import React from 'react';

import { CircledDottedScheme } from '../components/CircledDottedScheme';
import { CircledDottedSchemeProps } from '../components/CircledDottedSchemeDesktop';

import './CircledDottedScheme9.scss';

const CircledDottedScheme9 = (props: CircledDottedSchemeProps) => <CircledDottedScheme {...props} />;

export default CircledDottedScheme9;
